/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import "./App.scss";
import { getMotorcycleOptions, getMotorcycleQuote } from "./api";
import Button from "./components/Button";
import Quote from "./components/Quote";
import BlueBookForm from "./components/Form";
import { LoadingWrapper } from "./components/Loader";
import { Error } from "./components/Error";

type motorcycle = {
  make: string | null;
  year: string | null;
  model: string | null;
};

const getSelectOptions = (data: any) =>
  data ? data.map((m: string) => ({ value: m, label: m })) : undefined;

function App() {
  const [motorcycle, setMotorcycle] = useState<motorcycle>({
    make: null,
    year: null,
    model: null,
  });

  const [isLoading, setIsLoading] = useState({
    make: false,
    year: false,
    model: false,
  });

  const [quote, setQuote] = useState<string | null>(null);
  const [options, setOptions] = useState({
    makes: null,
    years: null,
    models: null,
  });

  const getOptions = useCallback(async () => {
    setIsLoading((prev) => ({ ...prev, make: true }));
    const { data } = await getMotorcycleOptions(motorcycle);
    setOptions((prev) => ({
      ...prev,
      makes: getSelectOptions(data),
    }));
    setIsLoading((prev) => ({ ...prev, make: false }));
  }, [motorcycle]);

  const getQuote = useCallback(async () => {
    if (motorcycle.make && motorcycle.year && motorcycle.model) {
      const { data } = await getMotorcycleQuote(motorcycle);
      let value: string;
      if (
        data &&
        data[0] &&
        `${motorcycle.year}` === `${new Date().getFullYear()}`
      ) {
        value = `$${data[0].msrp.toLocaleString(undefined, {
          maximumFractionDigits: 0,
        })} (MSRB)`;
      } else if (data && data[0]) {
        value = `$${data[0].r_clean.toLocaleString(undefined, {
          maximumFractionDigits: 0,
        })}`;
      } else {
        value = "No Value Provided";
      }
      setQuote(value);
    }
  }, [motorcycle]);

  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    getQuote();
  }, [getQuote]);

  const handleChangeMake = async (make: string) => {
    setQuote(null);
    setIsLoading((prev) => ({ ...prev, year: true }));
    setMotorcycle({ make, year: null, model: null });
    const { data } = await getMotorcycleOptions({ make, year: null });
    setOptions((prev) => ({
      ...prev,
      years: getSelectOptions(data),
    }));
    setIsLoading((prev) => ({ ...prev, year: false }));
  };

  const handleChangeYear = async (year: string) => {
    setQuote(null);
    setIsLoading((prev) => ({ ...prev, model: true }));
    setMotorcycle((prev) => ({ ...prev, year, model: null }));
    const { data } = await getMotorcycleOptions({ ...motorcycle, year });
    setOptions((prev) => ({
      ...prev,
      models: getSelectOptions(data),
    }));
    setIsLoading((prev) => ({ ...prev, model: false }));
  };

  const handleChangeModel = (model: string) => {
    setQuote(null);
    setMotorcycle((prev) => ({ ...prev, model }));
  };

  const { makes, years, models } = options;

  // @ts-ignore
  if ([makes, years, models].includes(undefined)) return <Error />;

  if (!makes) return <LoadingWrapper />;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <BlueBookForm
          motorcycle={motorcycle}
          options={options}
          isLoading={isLoading}
          handleChangeMake={handleChangeMake}
          handleChangeYear={handleChangeYear}
          handleChangeModel={handleChangeModel}
        />
        <Quote motorcycle={motorcycle} quote={quote} />
        <Button />
      </div>
    </div>
  );
}

export default App;
